import api from './api'

export const notificacionService = {
  // Listar notificaciones del usuario autenticado
  async getAll(params = {}) {
    const response = await api.get('/notificaciones', { params })
    return response.data
  },

  // Obtener notificación específica
  async getById(id) {
    const response = await api.get(`/notificaciones/${id}`)
    return response.data
  },

  // Obtener contador de notificaciones no leídas
  async getContadorNoLeidas() {
    const response = await api.get('/notificaciones/contador')
    return response.data
  },

  // Marcar notificación como leída
  async marcarLeida(id) {
    const response = await api.post(`/notificaciones/${id}/marcar-leida`)
    return response.data
  },

  // Marcar todas las notificaciones como leídas
  async marcarTodasLeidas() {
    const response = await api.post('/notificaciones/marcar-todas-leidas')
    return response.data
  },

  // Ocultar todas las notificaciones (soft delete)
  async deleteSoftAll() {
    try {
      const response = await api.post('/notificaciones/ocultar-todas')
      return response.data
    } catch (err) {
      const status = err.response?.status
      // Si el endpoint no existe aún en backend, dejamos que la UI haga fallback por lote.
      if (status === 404 || status === 405) {
        return { success: false, error: 'ENDPOINT_NOT_AVAILABLE' }
      }
      throw err
    }
  },

  // Eliminar notificación (borrado duro; si el backend usa soft delete aquí, seguirá siendo la misma URL)
  async delete(id) {
    const response = await api.delete(`/notificaciones/${id}`)
    return response.data
  },

  /**
   * Ocultar / archivar notificación (soft delete).
   * Prueba PATCH `/notificaciones/:id/ocultar`; si no existe (404/405), intenta POST.
   */
  async deleteSoft(id) {
    try {
      const response = await api.patch(`/notificaciones/${id}/ocultar`)
      return response.data
    } catch (err) {
      const status = err.response?.status
      if (status === 404 || status === 405) {
        try {
          const response = await api.post(`/notificaciones/${id}/ocultar`)
          return response.data
        } catch (err2) {
          const status2 = err2.response?.status
          // Fallback ultra compatible: si el backend no tiene /ocultar,
          // usamos la eliminación estándar por id (en prod puede ser hard delete o soft delete).
          if (status2 === 404 || status2 === 405) {
            const response = await api.delete(`/notificaciones/${id}`)
            return response.data
          }
          throw err2
        }
      }
      throw err
    }
  },
}

